import { Typography, type TypographyProps } from '../Typography/Typography';
import { ComponentChild } from 'preact';
import ns from '../../translations';
import { useTranslation } from '../../../../utils/useTranslation';

export const UpcomingBadges = ({
  color,
  label,
  className,
}: {
  color: TypographyProps['color'];
  label?: string | ComponentChild;
  className?: string;
}) => {
  const { t } = useTranslation(ns);
  return (
    <span className={`${className} vgp-upcoming-container`}>
      <Typography
        className="vgp-upcoming-label"
        color={color}
        variant="label"
        size="medium"
        bold
      >
        {t('Sent')}
      </Typography>
      {label ? (
        <Typography
          className="vgp-upcoming-date"
          color={color}
          variant="label"
          size="medium"
          bold
        >
          {label}
        </Typography>
      ) : null}
    </span>
  );
};
